import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { API_BASE } from "@/lib/api";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const r = await axios.post(`${API_BASE}/member/auth/session`, { session_id: sessionId }, { withCredentials: true });
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { state: { user: r.data }, replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#F7F5F0] flex items-center justify-center">
      <div className="flex items-center gap-3 text-[#5C665A]">
        <Loader2 size={18} className="animate-spin" /> Signing you in…
      </div>
    </div>
  );
}
